import { CommonHero } from '@/CommonHero';
import { ImgBox } from '@/ImgBox';
import { graphql, useStaticQuery } from 'gatsby';
import { IGatsbyImageData, getImage } from 'gatsby-plugin-image';
import { Fragment } from 'react';
export { Head } from '../';

export default function Page() {
    type DataType = {
        allFile: {
            nodes: {
                img: IGatsbyImageData;
                id: string;
            }[];
        };
    };

    const {
        allFile: { nodes },
    }: DataType = useStaticQuery(graphql`
        query aboutUs {
            allFile(filter: { relativeDirectory: { eq: "about-us" } }, sort: { name: ASC }) {
                nodes {
                    img: childImageSharp {
                        gatsbyImageData(width: 400, height: 480)
                    }
                }
            }
        }
    `);

    const images = nodes.map(node => getImage(node.img) as IGatsbyImageData);

    const info = [
        {
            title: 'Christopher R. Morris, DMD, FAGD',
            description: (
                <p>
                    Dr. Morris completed his undergraduate degree from Dixie College in Utah and
                    earned a Doctor of Dental Medicine (DMD) degree from the University of
                    Louisville School of Dentistry. Following graduation, Dr. Morris completed a
                    one-year residency in Advanced Education in General Dentistry (AEGD) with the
                    U.S. Army for additional dental training, including dental implants, wisdom
                    tooth extraction, root canals, and more. During a deployment to Iraq, Dr. Morris
                    was the only dentist of 10,000 personnel.
                    <br /> <br />
                    With Dr. Morris now practicing in beautiful Littleton, Colorado, his patients
                    benefit from his comprehensive experience and enjoy the convenience of dentistry
                    at one dental office. Dr. Morris also completed additional education in dental
                    implants and IV sedation. Dr. Morris enjoys providing dental surgery like wisdom
                    teeth removal to his patients at a cost savings. He is a general dentist with
                    more than 15 years of surgery experience. He earned a Fellowship Award from the
                    Academy of General Dentistry (FAGD), an honor only five percent of dentists
                    achieve. Dr. Morris believes his skills, knowledge, and ability make him a
                    valued practitioner among Colorado’s dentists.
                    <br /> <br />
                    His credentials include: <br />
                    DMD from the University of Louisville School of Dentistry <br />
                    AEGD from the U.S. Army <br />
                    Fellow in the Academy of General Dentistry <br />
                    IV Moderate Sedation from Duquesne University <br />
                    Surgical and prosthetic implant training by Dr. Carl Misch <br />
                    Teeth XPress full mouth implant training by BioHorizons
                    <br /> <br />
                    Dr. Morris’s hobbies include home improvement, CrossFit, hiking, camping, and
                    video editing. He and his wife Cori have four children - two boys and twin
                    girls.
                </p>
            ),
            image: images[0],
        },
        {
            title: 'Cori J. Morris, DDS',
            description: (
                <p>
                    Dr. Cori Morris graduated from the University of Colorado School of Dental
                    Medicine with distinction to earn her Doctorate of Dental Surgery (DDS) degree.
                    She enjoys volunteering her services on humanitarian trips to Honduras, at the
                    Worthmore clinic for refugees, and annually at COMOM (Colorado Mission of
                    Mercy). She continues to mentor students from the dental school as a preceptor.
                    <br /> <br />
                    Dr. Cori is friendly and compassionate. She is excited to provide dental
                    treatment to our patients in Littleton, Colorado. She is certified in nitrous
                    oxide / laughing gas delivery, oral sedation, and IV moderate sedation. She also
                    provides botox injections to treat TMD muscle tension and facial esthetics. Her
                    early career as a teacher gave her extensive training in child psychology,
                    development, and behavior management so she is excellent at treating children
                    and patients of all ages.
                    <br /> <br />
                    Her credentials include: <br />
                    BS in Elementary Education <br />
                    DDS from the University of Louisville School of Dental Medicine <br />
                    IV Moderate Sedation from Conscious Sedation Consulting <br />
                    Botox training from StatDDS <br /> <br />
                    Dr. Cori and her husband Chris have two teenage sons and twin daughters. They
                    love living in Colorado and enjoy hiking, biking, camping, and exploring the
                    vibrant city of Denver.
                </p>
            ),
            image: images[1],
        },
        {
            title: 'Arvella, Registered Dental Hygienist (RDH)',
            description: (
                <p>
                    Arvella is the full-time registered dental hygienist (RDH) at Morris Family
                    Dentistry. If asked, she’d tell you that she is not a Colorado native, but she
                    got here as soon as she could. Arvella grew up in Thornton and Aurora. She
                    received her RDH degree from Community College of Denver. She is adept at
                    treating children after more than 12 years working as a nanny to children of all
                    ages throughout Colorado’s front range area. Her hobbies including professional
                    singing, gardening, volunteering, and spending time with those she loves.
                    <br /> <br />
                    Arvella is happy to be a part of the team at Morris Family Dentistry where she
                    values building long-lasting relationships with our patients to best support
                    their long-term health.
                </p>
            ),
            image: images[2],
        },
    ];

    return (
        <Fragment>
            <CommonHero />
            {info.map((box, i) => (
                <ImgBox {...box} bigImg key={i} />
            ))}
        </Fragment>
    );
}
